import { gql } from "@apollo/client";

export const GET_TEAM = gql`
  query Teams($IdTeam: ID!, $State: PublicationState!) {
    team(id: $IdTeam, publicationState: $State) {
      id
      name
      colorShirt
      general_table {
        id
        pts
        gf
        ge
        jj
        jg
        je
        jp
      }
      players {
        id
        name
        app
        numShirt
        position
        yellowCard
        redCard
      }
      matchs {
        id
        day
        date
        hour
        goalLocal
        goalVisit
        StatusMatch
        type
        local {
          id
          name
          colorShirt
          general_table {
            id
            pts
          }
        }
        visit {
          id
          name
          colorShirt
          general_table {
            id
            pts
          }
        }
        stories {
          id
        }
      }
      teamVisits {
        id
        day
        date
        hour
        goalLocal
        goalVisit
        StatusMatch
        type
        local {
          id
          name
          colorShirt
          general_table {
            id
            pts
          }
        }
        visit {
          id
          name
          colorShirt
          general_table {
            id
            pts
          }
        }
        stories {
          id
        }
      }
      positions
    }
  }
`;

export const GET_MATCHES = gql`
  {
    matchs(where: {StatusMatch: "previa"}) {
      id
      day
      date
      hour
      goalLocal
      goalVisit
      StatusMatch
      live
      type
      local {
        id
        name
        shortName
        colorShirt
        general_table {
          id
          pts
        }
        players {
          id
          name
          app
        }
      }
      visit {
        id
        name
        shortName
        colorShirt
        general_table {
          id
          pts
        }
        players {
          id
          name
          app
        }
      }
    }
  }
`;

export const GET_MATCH = gql`
  query Matchs($IdMatch: ID!, $State: PublicationState!) {
    match(id: $IdMatch, publicationState: $State) {
      id
      StatusMatch
      type
      day
      local {
        id
        name
        players {
          id
          name
          app
          apm
          numShirt
        }
      }
      visit {
        id
        name
        players {
          id
          name
          app
          apm
        }
      }
    }
  }
`;

export const GET_TABLE = gql`
  {
    generalTables {
      id
      team {
        id
        name
        shortName
      }
      jj
      jg
      je
      jp
      gf
      ge
      dif
      pex
      pts
    }
  }
`;

export const GET_PLAYERS = gql`
  {
    players(limit: 5, sort: "goal:desc") {
      id
      name
      app
      goal
      team {
        id
        name
      }
    }
  }
`;

export const GET_PLAYER = gql`
  query Players($IdPlayer: ID!, $State: PublicationState!) {
    player(id: $IdPlayer, publicationState: $State) {
      id
      name
      app
      numShirt
      position
      goal
      yellowCard
      redCard
      played
      dayRegister
      team {
        id
        name
        colorShirt
        general_table {
          jj
        }
      }
    }
  }
`;

export const GET_MATCH_STORY = gql`
  query Matchs($IdMatch: ID!, $State: PublicationState!) {
    match(id: $IdMatch, publicationState: $State) {
      id
      day
      goalLocal
      goalVisit
      StatusMatch
      local {
        id
        name
        colorShirt
        general_table {
          id
          pts
          gf
          ge
          jg
          je
          jp
        }
        players {
          id
          numShirt
          name
          app
        }
      }
      visit {
        id
        name
        colorShirt
        general_table {
          id
          pts
          gf
          ge
          jg
          je
          jp
        }
        players {
          id
          numShirt
          name
          app
        }
      }
      stories {
        id
        title
        description
        minute
        type
        team
      }
    }
  }
`;

export const GET_TOURNAMENTS = gql`
  {
    tournaments {
      id
      name
      registerPlayers
      currentDay
    }
  }
`;

export const GET_TEAM_PLAYERS = gql`
  query Teams($IdTeam: ID!, $State: PublicationState!) {
    team(id: $IdTeam, publicationState: $State) {
      id
      name
      colorShirt
      players {
        id
        name
        app
        apm
        played
        createdAt
        dayRegister
      }
    }
  }
`;

export const GET_IDTEAMS = gql`
  {
    teams {
      id
    }
  }
`;